/* tslint:disable */
/* eslint-disable */
export enum DigitalWalletConfigError {
  NoAppleMerchantIdentifierCertificateConfigured = 'NoAppleMerchantIdentifierCertificateConfigured',
  NoAppleMerchantIdentifierRegistered = 'NoAppleMerchantIdentifierRegistered'
}
